import { render } from "./SetPlayersStart.vue?vue&type=template&id=c2669c7e&scoped=true"
import script from "./SetPlayersStart.vue?vue&type=script&lang=js"
export * from "./SetPlayersStart.vue?vue&type=script&lang=js"

import "./SetPlayersStart.vue?vue&type=style&index=0&id=c2669c7e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2669c7e"]])

export default __exports__